import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import DropdownActivator from 'scaleflow/utils/dropdown-activate';

export default class PeopleTableTableCellTeamsSelectIndexComponent extends DropdownActivator {
  @service store;

  @tracked teamFormIsVisible = false;

  selectedPerson = null;

  get person() {
    return this.args.person;
  }

  @action
  toggleTeamForm(person, val) {
    if (person) this.selectedPerson = person;
    else this.selectedPerson = null;
    if (val !== undefined) this.teamFormIsVisible = val;
    else this.teamFormIsVisible = !this.teamFormIsVisible;
  }

  get teamIds() {
    return (this.person.teams.content ?? []).map((team) => team.id);
  }

  @action
  async handleTeamClick(person, team_ids) {
    person.teams = team_ids
      .map((id) => this.store.peekRecord('team', id))
      .filter((item) => !!item);
    await person.save();
    person.reload();
  }

  @action
  async onTeamAdded(team) {
    const person = this.selectedPerson;
    const teams = (person.teams?.content ?? []).map((item) => item.id);
    teams.push(team.id);
    await this.handleTeamClick(person, teams);
  }

  willDestroy() {
    this.selectedPerson = null;
    this.teamFormIsVisible = false;
    super.willDestroy(...arguments);
  }
}
